import { Box } from '@mui/material';
import { useState } from 'react';
import ProgressBarCards from '/@/components/crop-monitoring/progress-bar-cards';
import Icon from '/@/components/icon';
import { _ } from '/@/locale';
import colors from '../../theme-provider/colors';
import ProgressBarTable from '../progress-bar-cp-dskt';
import CritialPeriodModal from './criticalperiodModal';

const ProgressBarMobile = ({
    cropMonitoring,
    showCropProtection,
    steps,
    activeStep,
    isActiveStep,
    getDate,
    getDataStep,
    technology,
    expectedFloweringDate,
    showAlert,
}) => {
    const [criticalPediodModalOpened, setCriticalPediodModalOpened] = useState(false);

    const getColorStep = (step, index, activeStep) => {
        if (!cropMonitoring?.id) return 'mute';
        if (activeStep > index) {
            return step.stage;
        } else {
            return 'mute';
        }
    };

    const getColorLineStep = (step, index, activeStep) => {
        if (!cropMonitoring?.id) return 'mute';
        if (activeStep > index + 1) {
            return step.stage;
        } else {
            return 'mute';
        }
    };

    return (
        <Box sx={{ display: 'flex', mt: 2 }}>
            <Box sx={{ mt: showCropProtection ? '0px' : '5px' }}>
                {steps.map((step, index) => (
                    <Box
                        sx={[
                            {
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '27px',
                                height: '27px',
                                p: 1,
                                m: 1,
                                my: showCropProtection ? 8 : 1,
                                border: `2px solid ${colors.cropMonitoring[getColorStep(step, index, activeStep)]}`,
                                borderRadius: '50%',
                                background: colors.cropMonitoring[getColorStep(step, index, activeStep)],
                                color: '#ffffff',
                                '&::after': {
                                    content: "''",
                                    background: colors.cropMonitoring[getColorLineStep(step, index, activeStep)],
                                    position: 'absolute',
                                    width: '0.25em',
                                    height: showCropProtection ? '95px' : '36px',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, 0)',
                                    zIndex: '-1',
                                },
                            },
                            step.empty &&
                                !isActiveStep(index, activeStep) && {
                                    border: 'none',
                                    background: 'none',
                                    color: 'transparent',
                                    pointerEvents: 'none',
                                },
                            index === steps.length - 1 && {
                                mb: 1,
                                '&::after': {
                                    display: 'none',
                                },
                            },
                            index === 0 && {
                                mt: 1,
                            },
                        ]}
                        key={index}
                    >
                        {(!step.empty || (step.empty && isActiveStep(index, activeStep))) &&
                            getDataStep(index, activeStep)}
                        {!step.empty && showCropProtection && (
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: '25px',
                                    width: '140%',
                                    fontSize: '10px',
                                    textAlign: 'center',
                                    background: 'white',
                                }}
                            >
                                <Box
                                    sx={{
                                        my: 0.5,
                                        py: 0.25,
                                        background: colors.cropMonitoring[getColorStep(step, index, activeStep + 1)],
                                        borderRadius: '10%',
                                        fontWeight: 'bold',
                                        color: 'white',
                                    }}
                                >
                                    {_(step.state)}
                                </Box>
                                <Box sx={{ my: 0.5, background: 'white', color: 'black' }}>{getDate(step, index)}</Box>

                                {showAlert && step.state === 'R' && (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            placeContent: 'center',
                                            cursor: 'pointer',
                                            zIndex: 1,
                                        }}
                                        onClick={() => setCriticalPediodModalOpened(true)}
                                    >
                                        <Icon type='info2' size='xs' />
                                    </Box>
                                )}
                            </Box>
                        )}
                    </Box>
                ))}
            </Box>
            {showCropProtection ? (
                <ProgressBarTable technology={technology} type='mobile' steps={steps} activeStep={activeStep} />
            ) : (
                <ProgressBarCards
                    cropMonitoring={cropMonitoring}
                    steps={steps}
                    activeStep={activeStep}
                    getDate={getDate}
                    expectedFloweringDate={expectedFloweringDate}
                    showAlert={showAlert}
                />
            )}

            <CritialPeriodModal
                expectedFloweringDate={expectedFloweringDate}
                open={criticalPediodModalOpened}
                setOpen={setCriticalPediodModalOpened}
            />
        </Box>
    );
};

export default ProgressBarMobile;
